import React from "react";

const GridBackground = ({
  children,
  bgColor = "#3498db",
  isCardCover = false,
}) => {
  return (
    <div
      className={`relative ${
        !isCardCover ? "min-h-screen" : "h-20"
      }  w-full flex items-center justify-center overflow-hidden`}
      style={{ backgroundColor: `${bgColor}33` }} // 20% Opazität (Hex: 33 entspricht 20%)
    >
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 40 0 L 0 0 0 40"
              fill="none"
              stroke={bgColor}
              strokeWidth="1"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default GridBackground;
